import { ACCEPT_JS_API_CREDENTIALS } from '../constants/api-constants';

const { test, prod } = ACCEPT_JS_API_CREDENTIALS;

const devSettings = {
  api: {
    memberCenterService: 'https://membercenterdev.drf.com',
    drfBaseUrl: 'https://dev.drf.com',
    shopPageUrl: 'https://shopdev.drf.com',
    staticServerUrl: 'https://static.drf.com/sstf/dev',
    registrationBaseUrl: 'https://registrationdev.drf.com',
    www1DrfUrl: 'https://www1int.drf.com',
    acceptJsUrl: 'https://jstest.authorize.net/v1/Accept.js',
    horseWatchBaseUrl: 'https://watchesstage.drf.com',
    formulatorBaseUrl: 'https://formulatordev.drf.com',
  },
  config: {
    acceptJsConfig: {
      credentials: test,
    },
  },
  APP_ENV: 'development',
};

const stageSettings = {
  api: {
    memberCenterService: 'https://membercenterstage.drf.com',
    drfBaseUrl: 'https://stage.drf.com',
    shopPageUrl: 'https://shopstage.drf.com',
    staticServerUrl: 'https://static.drf.com/sstf/stage',
    registrationBaseUrl: 'https://registrationstage.drf.com',
    www1DrfUrl: 'https://www1stage.drf.com',
    acceptJsUrl: 'https://jstest.authorize.net/v1/Accept.js',
    horseWatchBaseUrl: 'https://watchesstage.drf.com',
    formulatorBaseUrl: 'https://formulatorstage.drf.com',
  },
  config: {
    acceptJsConfig: {
      credentials: test,
    },
  },
  APP_ENV: 'staging',
};

export const prodSettings = {
  api: {
    memberCenterService: 'https://membercenter.drf.com',
    drfBaseUrl: 'https://www.drf.com',
    shopPageUrl: 'https://shop.drf.com',
    staticServerUrl: 'https://static.drf.com/sstf/prod',
    registrationBaseUrl: 'https://registration.drf.com',
    www1DrfUrl: 'https://www1.drf.com',
    acceptJsUrl: 'https://js.authorize.net/v1/Accept.js',
    horseWatchBaseUrl: 'https://watches.drf.com',
    formulatorBaseUrl: 'https://formulator.drf.com',
  },
  config: {
    acceptJsConfig: {
      credentials: prod,
    },
  },
  APP_ENV: 'production',
};

export const uatSettings = {
  api: {
    memberCenterService: 'https://membercenter.drf.com',
    drfBaseUrl: 'https://uat.drf.com',
    shopPageUrl: 'https://shopuat.drf.com',
    staticServerUrl: 'https://static.drf.com/sstf/prod',
    registrationBaseUrl: 'https://registration.drf.com',
    www1DrfUrl: 'https://www1.drf.com',
    acceptJsUrl: 'https://js.authorize.net/v1/Accept.js',
  },
  config: {
    acceptJsConfig: {
      credentials: prod,
    },
  },
  APP_ENV: 'uat',
};

/** Object containing common URLs and other configurations that are independent of the environment */
const commonSettings = {
  common: {
    promoPageUrl: 'https://promos.drf.com',
    smartyStreetUrl: 'https://us-autocomplete-pro.api.smartystreets.com/lookup',
  },
};

let settings = () => {
  switch (document.location.hostname) {
    case 'membercenterlocal.drf.com':
    case 'membercenterdev.drf.com':
      return { ...devSettings, ...commonSettings };
    case 'membercenterstage.drf.com':
      return { ...stageSettings, ...commonSettings };
    case 'membercenter.drf.com':
      return { ...prodSettings, ...commonSettings };
    case 'membercenteruat.drf.com':
      return { ...uatSettings, ...commonSettings };

    default:
      return { ...devSettings, ...commonSettings };
  }
};

export default settings();
